<template>
  <base-modal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_resubscribe_game_sms_title }}</h1>

      <p class="mt-40"><b>{{ $_getTranslations.home_modals_resubscribe_game_sms_not_subscribed_to_service }}</b></p>

      <p>{{ $_getTranslations.home_modals_resubscribe_game_sms_in_order_to }}</p>

      <p>
        {{ $_translateTextByOperator({key: 'home_modals_resubscribe_game_sms_instructions_pt1'}) }}
        <b>{{ $_translateTextByOperator({key: 'home_modals_resubscribe_game_sms_instructions_pt2'}) }}</b>
      </p>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '../../common/modal/BaseModal'
import translationMixin from '../../../common/mixins/translation'

export default {
  // modal_resubscribe_sms.html.html
  name: 'resubscribe-game-sms',
  components: {BaseModal},
  mixins: [translationMixin]
}
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeGameSms.vue